import {basicPublisher, basicRepositoryFactory, Publisher, WorkerConfig} from './publisher.js';
import {conflateRepo} from './common.js';
import * as core from './core.js';
import {getLogger} from '../logger.js';
import {IOGateway} from '../../gateway';

const log = getLogger('gateway.metrics.file');

export type FileConfig = IOGateway.FileMetricsPublisherConfig & WorkerConfig

async function filePublisher(config: FileConfig): Promise<Publisher> {
    const conflationMaxCount = config.conflation?.["max-datapoints-repo"] ?? 50;
    log.info(`will record metrics to ${config.location}`);
    return await basicPublisher(
        config,
        (data) => conflateRepo(conflationMaxCount ?? 1, data),
        config?.publishFn ?? '@interopio/gateway/metrics/publisher/file');
}

export async function fileRepositoryFactory(config: FileConfig) : Promise<core.RepositoryFactory> {
    return basicRepositoryFactory(config, await filePublisher(config));
}
